import { render, staticRenderFns } from "./KplaySlot.vue?vue&type=template&id=0845734a&scoped=true"
import script from "./KplaySlot.vue?vue&type=script&lang=js"
export * from "./KplaySlot.vue?vue&type=script&lang=js"
import style0 from "./KplaySlot.vue?vue&type=style&index=0&id=0845734a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845734a",
  null
  
)

export default component.exports